export default "__VITE_ASSET__23a3f3a9__"